import script from "./MainView.vue?vue&type=script&setup=true&lang=js"
export * from "./MainView.vue?vue&type=script&setup=true&lang=js"

import "./MainView.vue?vue&type=style&index=0&id=7f47624b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f47624b"]])

export default __exports__